export enum ApplyToEnum {
        AllScreens = 1099,
        NewbornOnly = 1100,
        AllEXCEPTNewborn = 1101,
        MainSelectionScreenOnly = 1103,
}
